import { render, staticRenderFns } from "./input-button-variant.vue?vue&type=template&id=124161ba&scoped=true"
import script from "./input-button-variant.vue?vue&type=script&lang=js"
export * from "./input-button-variant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124161ba",
  null
  
)

export default component.exports